import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import VivoAvatar from "@assets/img/avatar.png";
import { useHistory } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  image: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  grid: {
    justifyContent: "center",
    alignItems: "center",
  },
}));

function HireItNow(props) {
  const classes = useStyles();
  const history = useHistory();

  function onCancel() {
    history.push("/login");
  }

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCancel}
      maxWidth="md"
    >
      <DialogTitle>Quero contratar agora</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} sm={9}>
            <Typography>
              Para contratação do serviço procure o seu gerente de contas ou
              parceiro Vivo Empresas mais próximo de você.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.image}>
              <img
                src={VivoAvatar}
                alt="Avatar da Vivo"
                height="70px"
                width="70px"
              />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

HireItNow.propTypes = {
  open: PropTypes.bool.isRequired,
};

HireItNow.defaultProps = {
  open: false,
};

export default HireItNow;
